import config from "@/config"
import http from "@/utils/request"

const storeApplicationUrl = `${config.API_URL}/application`
export default {
  application: {
    store: {
      // url: `${config.API_URL}/system/menu/my/1.6.1`,
      url: storeApplicationUrl,
      name: "入驻店铺",
      get: async function (params) {
        return await http.get(`${this.url}/manage/store/applyList`, params)
      },
      submitStoreReview: async function (data) {
        return await http.post(`${this.url}/manage/store/submitReview`, data)
      },
      getApplicationReviewOperate: async function (data) {
        return await http.post(`${this.url}/manage/store/submitReview`, data)
      },
      reviewOperateList: async function (data) {
        return await http.post(`${this.url}/manage/reviewOperate/list`, data)
      },
      getApprovedApplyList: {
        get: async function (params) {
          return await http.get(`${storeApplicationUrl}/manage/store/getApprovedApplyList`, params)
        },
        reviewOperateList: async function (data) {
          return await http.post(`${storeApplicationUrl}/manage/reviewOperate/list`, data)
        }
      }
    }
  },
  menu: {
    myMenus: {
      // url: `${config.API_URL}/system/menu/my/1.6.1`,
      url: `${config.API_URL}/manage/menu/list`,
      name: "获取我的菜单",
      get: async function () {
        return await http.get(this.url)
      }
    },
    list: {
      url: `${config.API_URL}/manage/menu`,
      name: "获取菜单",
      get: async function (params) {
        return await http.get(`${this.url}/list`, params)
      },
      submit: async function (data) {
        return await http.post(`${this.url}/submit`, data)
      }
    }
  },
  user: {
    list: {
      url: `${config.API_URL}/user`,
      name: "获取用户",
      get: async function (params) {
        return await http.get(`${this.url}/userlist`, params)
      },
      submit: async function (data) {
        return await http.post(`${this.url}/manage/updateUser`, data)
      },
      del: async function (data) {
        return await http.post(`${this.url}/delete`, data)
      },
      disabled: async function (data) {
        return await http.post(`${this.url}/manage/disabled`, data)
      }
    }
  },
  dict: {
    url: `${config.API_URL}/dict`,
    name: "获取字典",
    get: async function (params) {
      return await http.get(`${this.url}/listTree`, params)
    },
    submit: async function (data) {
      return await http.post(`${this.url}/submit`, data)
    },
    del: async function (data) {
      return await http.post(`${this.url}/delete`, data)
    },
    dictList: async function (params) {
      return await http.get(`${this.url}/list`, params)
    }
  },
  permission: {
    list: {
      url: `${config.API_URL}/permission`,
      name: "获取角色列表",
      get: async function (params) {
        return await http.get(`${this.url}/list`, params)
      },
      submit: async function (data) {
        return await http.post(`${this.url}/submit`, data)
      },
      del: async function (data) {
        return await http.post(`${this.url}/delete`, data)
      }
    }
  }
}
